module.exports = __webpack_public_path__ + "static/images/components/ModernizationOverlay/images/modernization-bg-100.b2573a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/ModernizationOverlay/images/modernization-bg-100.jpg
// module id = 2609
// module chunks = 11